export default "__VITE_ASSET__CFDvbIHX__"